<template>
    <div class="modal fade" id="viewPrintDimandProbeshnoryNote">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printDimandProbeshnoryNote()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printDimandProbeshnoryNote">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <table class="table printing">
                        <thead>
                          <td width="18%" v-if="myhost !== 'fincare.13squad.com'"><img :src="logo" height="90" width="100%"></td>
                          <td class="text-center">
                            <h4>
                              <span v-if="myhost !== 'fincare.13squad.com'">
                                <strong>{{getCompanyRecord.companyName}}</strong> <br> 
                                <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                                <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                                </small><br><br><br>
                              </span>
                              <strong v-if="myhost === 'progati.micromuneem.com' || myhost === 'bmcf.microfinancesoftware.in'">ডিমান্ড প্রামিসরি নোট <br>(Demand Promissory Note)</strong>
                              <strong v-else-if="myhost === 'fincare.13squad.com'"> ప్రామిసరీ నోటు <br>(Demand Promissory Note)</strong>
                              <strong v-else>डिमांड प्रामिसरी नोट <br>(Demand Promissory Note)</strong>
                            </h4>
                          </td>
                          <td class="text-right" width="20%" v-if="seeRecord.member_loan_plan">
                            <div v-if="seeRecord.member_loan_plan">
                              <barcode v-bind:value="seeRecord.member_loan_plan.applicationNo" height="45" width="1">
                                Show this if the rendering fails.
                              </barcode>
                            </div>
                          </td>
                        </thead>
                      </table>
                      <!-- <hr width="100%" style="height:5px;border-width:0;color:black;background-color:black"> -->
                      <div>
                        <p v-if="myhost === 'progati.micromuneem.com' || myhost === 'bmcf.microfinancesoftware.in'">
                          <strong>পরিমাণ : ₹ {{planAmt(seeRecord)}}</strong><br>
                            <big v-if="seeRecord.member_id" class="text-justify">
                              এটি প্রত্যয়িত করার জন্য যে, আমি/আমরা <strong>{{ seeRecord.member.name }}</strong> c/o  <strong v-if="mem.gender == 'Male'">{{mem.fatherName}}</strong><strong v-else>{{mem.spouseName}}</strong>, <b>{{mem.address}}</b> জেলা <b>{{mem.district}}</b> <b v-if="mem.state">রাজ্য {{mem.state.name}},</b> <b> {{mem.pin}}</b> বাসিন্দা, {{getCompanyRecord.companyName}} द्থেকে <strong> ₹ {{planAmt(seeRecord)}}
                              </strong> টাকা ঋণ নিয়েছি। এতদ্বারা আমি/আমরা   আমার/আমাদের ঋণ পরিশোধের সময়সূচী অনুযায়ী EMI কিস্তি পরিশোধ করার প্রতিশ্রুতি দিচ্ছি যা পূর্বে আমার দ্বারা চেক করা হয়েছিল এবং ঋণের আবেদনপত্রে স্বাক্ষর করা হয়েছিল।
                              <!-- <b><span v-if="pl.rateOfInterest">{{pl.rateOfInterest}}</span><span v-else>__</span>%</b>
                              <b>22.7%</b>
                               वार्षिक <span v-if="pl.typeOfInterest === 'reduced'">घटती </span> ब्याज की दर से तुरंत जमा करा दूंगा / दूंगी -->
                            </big>
                            <br><br>
                            <!-- <strong>Amount : ₹ <i v-if="pl.planType === 'normalReduced' || pl.planType === 'special'">{{ showPlanAmtReduced(pl) }}</i> -->
                            <strong>Amount : ₹ {{planAmt(seeRecord)}}</strong><br>
                              <big v-if="seeRecord.member_id" class="text-justify">
                                This is to certify that I, <b>{{ seeRecord.member.name }}</b> C/O <strong v-if="mem.gender == 'Male'">{{mem.fatherName}}</strong><strong v-else>{{mem.spouseName}}</strong> , resident at <b>{{mem.address}}</b> District - <b>{{mem.district}}</b>, State - <b v-if="mem.state">{{mem.state.name}}</b> 
                                has taken a loan of amount Rs. {{planAmt(seeRecord)}} from {{getCompanyRecord.companyName}} .
                                <!-- at 
                                <b><span v-if="pl.rateOfInterest > 0">{{pl.rateOfInterest}}</span><span v-else>__</span>%</b> -->
                                <!-- <b>22.7%</b> 
                                interest rate. -->

                                I hereby promise to pay the EMI instalments as per the schedule of my loan repayment that was previously checked and signed by me in the Loan Application Form.
                              </big>
                          </p>
                          <p v-else>
                            <strong>राशि : ₹ {{planAmt(seeRecord)}}</strong><br>
                              <big v-if="seeRecord.member_id" class="text-justify">
                                {{getCompanyRecord.companyName}} मैं श्री <strong>{{ seeRecord.member.name }}</strong> c/o  <strong v-if="mem.gender == 'Male'">{{mem.fatherName}}</strong><strong v-else>{{mem.spouseName}}</strong> निवासी <b>{{mem.address}}</b> जिला <b>{{mem.district}}</b> <b v-if="mem.state">राज्य {{mem.state.name}},</b> <b> {{mem.pin}}</b> का मूल निवासी हूँ, {{getCompanyRecord.companyName}} द्वारा मांगे जाने पर मेरे द्वारा प्राप्त की गई ऋण राशि रुपए <strong> ₹ {{planAmt(seeRecord)}}
                                </strong> को 
                                मैं अपने ऋण चुकौती की अनुसूची के अनुसार ईएमआई किस्तों का भुगतान करने का वादा करता हूं, 
                                जिसे पहले ऋण आवेदन पत्र में मेरे द्वारा जांचा और हस्ताक्षरित किया गया था।
                                <!-- <b><span v-if="pl.rateOfInterest">{{pl.rateOfInterest}}</span><span v-else>__</span>%</b>
                                <b>22.7%</b>
                                वार्षिक <span v-if="pl.typeOfInterest === 'reduced'">घटती </span> ब्याज की दर से तुरंत जमा करा दूंगा / दूंगी -->
                              </big>
                              <br><br>
                              <!-- <strong>Amount : ₹ <i v-if="pl.planType === 'normalReduced' || pl.planType === 'special'">{{ showPlanAmtReduced(pl) }}</i> -->
                              <strong>Amount : ₹ {{planAmt(seeRecord)}}</strong><br>
                                <big v-if="seeRecord.member_id" class="text-justify">
                                  This is to certify that I, <b>{{ seeRecord.member.name }}</b> C/O <strong v-if="mem.gender == 'Male'">{{mem.fatherName}}</strong><strong v-else>{{mem.spouseName}}</strong> , resident at <b>{{mem.address}}</b> District - <b>{{mem.district}}</b>, State - <b v-if="mem.state">{{mem.state.name}}</b> 
                                  has taken a loan of amount Rs. {{planAmt(seeRecord)}} from {{getCompanyRecord.companyName}} .
                                  <!-- at 
                                  <b><span v-if="pl.rateOfInterest > 0">{{pl.rateOfInterest}}</span><span v-else>__</span>%</b> -->
                                  <!-- <b>22.7%</b> 
                                  interest rate. -->

                                  I hereby promise to pay the EMI instalments as per the schedule of my loan repayment that was previously checked and signed by me in the Loan Application Form.
                                </big>
                            </p>
                            <br>
                            <strong>Date: {{seeRecord.disbursementDate | myDate}}</strong>
                      </div><br><br><br><br><br><br><br><br><br><br><br><br><br>
                        <p><table class="table" width="100%">
                            <thead v-if="myhost === 'progati.micromuneem.com' || myhost === 'bmcf.microfinancesoftware.in'">
                              <th>Member Signature <br>((সদস্যের স্বাক্ষর))</th>
                              <th>Guarantor Signature <br>(গ্যারেন্টারের স্বাক্ষর)</th>
                              <th>Branch Seal With Signature <br>(শাখা সিল স্বাক্ষর সহ)</th>
                            </thead>
                            <thead v-else>
                              <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                              <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                              <th>Branch Seal With Signature <br>(शाखा मोहर के साथ हस्ताक्षर)</th>
                            </thead>
                          </table>
                        </p>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  </div>
                  <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    
</template>
<script>
import { Printd } from 'printd'
import VueBarcode from 'vue-barcode'
export default {
  name: 'PropsTesting',
  data () {
    return {
      myhost: location.host,
      cssText: `.printing {
        font-family: sans-serif;
        text-align: center;
        padding-bottom: 2rem;

        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
      }
      p {
        text-align: justify;
      }
      @page {
        size: A4;
        margin: 2;
      }
      table.center {
        margin-left: auto; 
        margin-right: auto;
      }
      table, th, td { border:1px solid #000; padding:0.5em; border-collapse: collapse; }`
    }
  },
  methods: {
    planAmt (row) {
      // table, th, td { border:1px solid #000; padding:0.5em; border-collapse: collapse; }
      var fpi = 0
      var gstAmt = 0
      var pln = JSON.parse(row.plan)
      if (pln.planType !== 'normal') {
        if (pln.fileChargeIncludeAmt === 'true') {
          fpi += row.fileCharge ? row.fileCharge : parseInt(pln.fileCharge)
        }
        if (pln.processingFeeIncludeAmt === 'true') {
          fpi += row.processingFee ? row.processingFee : parseInt(pln.processingFee)
        }
        if (pln.insuranceFeeIncludeAmt === 'true') {
          fpi += row.insuranceFee ? row.insuranceFee : parseInt(pln.insuranceFee)
        }
        if (pln.includeGst === 'true') {
          gstAmt = fpi * 18 / 100
          fpi += parseInt(gstAmt)
        }
        return row.loanAmount ? row.loanAmount + fpi : pln.amount + fpi
      } else {
        return row.loanAmount ? row.loanAmount : pln.amount
      }
    },
    showPlanAmtNormal (pl) {
      // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.amount * pl.processingFee) / 100
      if (this.seeRecord.loanAmount) {
        return this.seeRecord.loanAmount
      } else {
        return pl.amount
      }
    },
    showPlanAmtReduced (pl) {
      var fpi = 0
      var gstAmt = 0
      if (pl.fileChargeIncludeAmt === 'true') {
        fpi += this.seeRecord.fileCharge ? this.seeRecord.fileCharge : parseInt(pl.fileCharge)
      }
      if (pl.processingFeeIncludeAmt === 'true') {
        fpi += this.seeRecord.processingFee ? this.seeRecord.processingFee : parseInt(pl.processingFee)
      }
      if (pl.insuranceFeeIncludeAmt === 'true') {
        fpi += this.seeRecord.insuranceFee ? this.seeRecord.insuranceFee : parseInt(pl.insuranceFee)
      }
      if (pl.includeGst === 'true') {
        gstAmt = fpi * 18 / 100
        fpi += parseInt(gstAmt)
      }
      return this.seeRecord.loanAmount ? this.seeRecord.loanAmount + fpi : parseInt(pl.amount) + fpi
    },
    printDimandProbeshnoryNote () {
      // Get HTML to print from element
      const d = new Printd()
      d.print(document.getElementById('printDimandProbeshnoryNote'), [this.cssText])
    }
  },
  components: {
    'barcode': VueBarcode
  },
  props: {
    seeRecord: {},
    memberDetail: {},
    mem: {},
    pl: {},
    logo: '',
    getCompanyRecord: {}
  }
}
</script>



// WEBPACK FOOTER //
// DemandProbeshnaryNote.vue?73b80893